/* Browser-local preference store. No Swym dependency; analytics uses the existing Google tag. */
(function () {
  'use strict';
  if (window.UMMyCollection) return;
  var config = document.getElementById('um-my-collection-config');
  if (!config) return;
  var KEY = 'um_my_collection_v1';
  var productNode = config.querySelector('[data-um-my-collection-product]');
  var product = productNode ? JSON.parse(productNode.textContent) : null;
  var gridProducts = new WeakMap();
  function productForButton(button) {
    var raw = button.getAttribute && button.getAttribute('data-um-my-collection-artwork');
    if (raw === null || raw === undefined) return product;
    if (!gridProducts.has(button)) {
      try { gridProducts.set(button, JSON.parse(raw)); } catch (_) { gridProducts.set(button, null); }
    }
    return gridProducts.get(button);
  }
  var imageUpdatesNode = config.querySelector('[data-um-my-collection-image-updates]');
  var imageUpdates = [];
  var imageRepairPending = false;
  try { imageUpdates = imageUpdatesNode ? JSON.parse(imageUpdatesNode.textContent) : []; } catch (_) { /* Keep saved data if optional preview metadata cannot be read. */ }
  if (!Array.isArray(imageUpdates)) imageUpdates = [];
  imageUpdates = imageUpdates.filter(function (item) {
    return item && item.imageSourceVersion === 2 &&
      artwork(Object.assign({}, item, {savedAt: new Date().toISOString()}));
  });
  var listeners = [];
  var lastError = '';
  function empty() { return { schemaVersion: 1, updatedAt: '', favourites: [], walls: [] }; }
  function fail(message) { throw new Error(message); }
  function text(value, max) { return typeof value === 'string' && value.length <= max; }
  function id(value) { return typeof value === 'string' && /^\d{1,30}$/.test(value); }
  function url(value, isProduct) {
    if (typeof value !== 'string' || value.length > 3000 || !value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.username || parsed.password || !/^https?:$/.test(parsed.protocol)) return '';
      if (isProduct && (parsed.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(parsed.pathname))) return '';
      if (!isProduct && parsed.protocol !== 'https:' && parsed.origin !== window.location.origin) return '';
      return parsed.href;
    } catch (_) { return ''; }
  }
  function artwork(item) {
    return item && id(item.productId) && text(item.handle, 255) && /^[a-zA-Z0-9-]+$/.test(item.handle) &&
      text(item.title, 1000) && !!url(item.url, true) && text(item.imageUrl, 3000) &&
      (!item.imageUrl || !!url(item.imageUrl, false)) && Number.isFinite(item.aspectRatio) && item.aspectRatio > 0 && item.aspectRatio < 100 &&
      ['clean-artwork', 'product-photo'].includes(item.imageType) && (!item.variantId || id(item.variantId)) &&
      text(item.optionSummary || '', 1000) && text(item.savedAt, 40) && Number.isFinite(Date.parse(item.savedAt)) &&
      (item.personalisationNotSaved === undefined || typeof item.personalisationNotSaved === 'boolean') &&
      (item.productType === undefined || text(item.productType, 255)) &&
      (item.qa === undefined || typeof item.qa === 'boolean');
  }
  function validate(data) {
    var bad = 'Stored collection data is not recognised. It has been kept unchanged; this browser cannot update it.';
    if (!data || data.schemaVersion !== 1 || !text(data.updatedAt, 40) || !Array.isArray(data.favourites) || !Array.isArray(data.walls) || data.favourites.length > 100 || data.walls.length > 10) fail(bad);
    if (!data.favourites.every(artwork) || new Set(data.favourites.map(function (a) { return a.productId; })).size !== data.favourites.length) fail(bad);
    if (!data.walls.every(function (wall) { return validWall(wall, false); }) || new Set(data.walls.map(function (w) { return w.id; })).size !== data.walls.length) fail(bad);
    if (data.workingDraft != null) {
      var draft=data.workingDraft;
      if (!text(draft.id,100) || !/^[\w-]+$/.test(draft.id) || !Number.isSafeInteger(draft.revision) || draft.revision < 1 ||
          !text(draft.updatedAt,40) || !Number.isFinite(Date.parse(draft.updatedAt)) || !validWall(draft.wall,true) ||
          (draft.baseWall !== null && !validWall(draft.baseWall,false))) fail(bad);
    }
    return data;
  }
  function validWall(wall, isDraft) {
    return !!(wall && (isDraft && !wall.id || text(wall.id,100) && /^[\w-]+$/.test(wall.id)) &&
      text(wall.name,80) && (isDraft || wall.name.trim()) && ['row','grid','feature','stacked','staggered'].includes(wall.layout) &&
      (wall.spacing === undefined || ['close','regular','airy'].includes(wall.spacing)) &&
      (wall.wallColour === undefined || ['warm','stone','grey'].includes(wall.wallColour)) &&
      (isDraft || text(wall.createdAt,40) && Number.isFinite(Date.parse(wall.createdAt)) && text(wall.updatedAt,40) && Number.isFinite(Date.parse(wall.updatedAt))) &&
      Array.isArray(wall.artworks) && wall.artworks.length >= (isDraft?0:1) && wall.artworks.length <= 6 && wall.artworks.every(artwork) &&
      new Set(wall.artworks.map(function (a) {return a.productId;})).size === wall.artworks.length);
  }
  function permitted() {
    try { return !!window.Shopify.customerPrivacy.preferencesProcessingAllowed(); } catch (_) { return false; }
  }
  function read() {
    if (!permitted()) fail('Browser saving is unavailable until preference storage is permitted in the store’s privacy settings.');
    var raw;
    try { raw = window.localStorage.getItem(KEY); } catch (_) { fail('Browser storage is unavailable. Your changes cannot be saved.'); }
    if (raw === null) return empty();
    var data;
    try { data = JSON.parse(raw); } catch (_) { fail('Stored collection data could not be read. It has been kept unchanged.'); }
    return validate(data);
  }
  function notify() { sync(); listeners.forEach(function (fn) { fn(); }); repairFavouriteImages(); }
  function repairFavouriteImages() {
    if (imageRepairPending || !imageUpdates.length) return;
    var data;
    try { data = read(); } catch (_) { return; }
    function replacement(item) {
      return !item.qa && item.imageSourceVersion !== 2 && imageUpdates.find(function (update) { return update.productId === item.productId && update.handle === item.handle; });
    }
    if (!data.favourites.some(replacement)) return;
    imageRepairPending = true;
    mutate(function (latest) {
      latest.favourites.forEach(function (item) {
        var update = replacement(item);
        if (!update) return;
        item.imageUrl = update.imageUrl ? url(update.imageUrl, false) : '';
        item.aspectRatio = update.aspectRatio;
        item.imageType = update.imageType;
        item.imageSourceVersion = 2;
      });
      // Existing walls retain their independent snapshots and draft/save semantics.
    }).catch(function (error) { message(error.message); }).finally(function () { imageRepairPending = false; });
  }
  function mutate(change) {
    function run() {
      var data = read(); // Re-read immediately before every mutation, including other-tab changes.
      change(data);
      data.updatedAt = new Date().toISOString();
      validate(data);
      try { window.localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) { fail('Could not save: browser storage is unavailable or full. Your change was not saved.'); }
      notify();
      return data;
    }
    // Web Locks serialize cooperating tabs where supported; read-before-write is the fallback.
    if (window.navigator.locks) return window.navigator.locks.request(KEY, run);
    return Promise.resolve().then(run);
  }
  var noticeTimer, noticeClearTimer;
  function pauseNotice(notice) {
    window.clearTimeout(noticeTimer); window.clearTimeout(noticeClearTimer);
    notice.classList.remove('is-fading');
  }
  function dismissNoticeLater(notice) {
    pauseNotice(notice);
    if (notice.contains(document.activeElement)) return;
    noticeTimer = window.setTimeout(function () {
      if (notice.contains(document.activeElement)) return;
      notice.classList.add('is-fading');
      noticeClearTimer = window.setTimeout(function () {
        notice.replaceChildren(); notice.classList.remove('is-fading');
      }, 250);
    }, 5000);
  }
  function message(value, link) {
    var notice = document.querySelector('[data-um-my-collection-notice]');
    if (!notice) return;
    pauseNotice(notice);
    notice.replaceChildren(document.createTextNode(value));
    if (link) {
      notice.appendChild(document.createTextNode(' · '));
      var a = document.createElement('a'); a.href = config.dataset.pageUrl; a.textContent = 'View collection'; notice.appendChild(a);
    }
    if (!notice.__umDismissBound) {
      notice.__umDismissBound = true;
      notice.addEventListener('focusin', function () { pauseNotice(notice); });
      notice.addEventListener('focusout', function (event) {
        if (!notice.contains(event.relatedTarget)) dismissNoticeLater(notice);
      });
    }
    dismissNoticeLater(notice);
  }
  function revealCollectionAccess() {
    var panels = document.querySelectorAll('.um-my-collection-access:not([data-um-my-collection-ready])');
    if (!panels.length) return;
    panels.forEach(function (panel) { panel.setAttribute('data-um-my-collection-ready', 'pending'); });
    function reveal() {
      // State is already synchronized. Let fonts and responsive layout settle
      // before revealing; do not repeat this on saves or storage updates.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          panels.forEach(function (panel) {
            if (!panel.isConnected) return;
            panel.setAttribute('data-um-my-collection-ready', 'true');
            panel.style.removeProperty('visibility');
          });
        });
      });
    }
    Promise.resolve(document.fonts && document.fonts.ready).then(reveal, reveal);
  }
  function sync() {
    var data, error = '';
    try { data = read(); } catch (e) { data = empty(); error = e.message; }
    lastError = error;
    var savedIds = new Set(data.favourites.map(function (a) { return a.productId; }));
    document.querySelectorAll('[data-um-my-collection-heart]').forEach(function (button) {
      var item = productForButton(button);
      var saved = item && savedIds.has(item.productId);
      button.disabled = !!error || !item;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', saved ? 'Remove from My Collection' : 'Save to My Collection');
      var label = button.querySelector('.um-my-collection-heart__text');
      if (label) label.textContent = saved ? (button.dataset?.savedLabel || 'Saved artwork') : (button.dataset?.saveLabel || 'Save artwork');
    });
    document.querySelectorAll('[data-um-my-collection-count]').forEach(function (node) { node.textContent = error ? '' : '(' + data.favourites.length + ')'; });
    document.querySelectorAll('[data-um-my-collection-nonempty]').forEach(function (node) { node.hidden = !!error || !data.favourites.length; });
    document.querySelectorAll('[data-um-my-collection-persistence]').forEach(function (node) { node.textContent = error || 'Saved on this browser.'; });
    revealCollectionAccess();
    return data;
  }
  function productLink(item) {
    var root = config.dataset.root.replace(/\/?$/, '/');
    var result = new URL(root + 'products/' + encodeURIComponent(item.handle), window.location.origin);
    if (item.variantId) result.searchParams.set('variant', item.variantId);
    return result.href;
  }
  function track(eventName, parameters) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return false;
      // Order attribution is independent of Google tag delivery or blockers.
      try { if (window.UMMyCollectionAttribution) window.UMMyCollectionAttribution.record(eventName); } catch (_) {}
      var payload = {
        send_to: 'G-SR3GHL7253',
        // Exclude shared-configuration hashes and query strings.
        page_location: window.location.origin + window.location.pathname
      };
      // Never forward wall names, custom wording, URLs, or complete saved records.
      ['product_id', 'variant_id', 'source', 'action', 'tab', 'save_type', 'artwork_count',
        'saved_count', 'wall_count', 'layout', 'spacing', 'wall_colour'].forEach(function (key) {
        if (parameters && parameters[key] !== undefined) payload[key] = parameters[key];
      });
      window.dataLayer = window.dataLayer || [];
      var send = typeof window.gtag === 'function' ? window.gtag : function () { window.dataLayer.push(arguments); };
      send('event', eventName, payload);
      return true;
    } catch (_) { return false; } // Analytics must never prevent saving or editing.
  }
  // Read the real master selector at click time; never maintain a competing variant state.
  function snapshot(button) {
    var item = Object.assign({}, productForButton(button));
    if (!(button.hasAttribute && button.hasAttribute('data-um-my-collection-artwork'))) {
      var form = button.closest('form.product-single__form');
      // Grid cards keep their own variant; never borrow a nearby PDP selector.
      var select = (form && form.querySelector('[data-product-select]')) || document.querySelector('[data-product-select]');
      var selected = select && select.selectedOptions[0];
      item.variantId = selected && id(String(selected.value)) ? String(selected.value) : '';
      // Never save the price embedded in the master option's display text.
      item.optionSummary = selected ? (selected.getAttribute('data-um-my-collection-options') || '').slice(0, 1000) : '';
    }
    item.savedAt = new Date().toISOString();
    item.url = url(item.url, true);
    item.imageUrl = item.imageUrl ? url(item.imageUrl, false) : '';
    return item;
  }
  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-um-my-collection-heart]');
    if (!button || button.disabled) return;
    var targetProduct = productForButton(button);
    if (!targetProduct) return;
    event.preventDefault();
    var added = false;
    var changedItem;
    try {
      var updated = await mutate(function (data) {
        var at = data.favourites.findIndex(function (a) { return a.productId === targetProduct.productId; });
        if (at >= 0) changedItem = data.favourites.splice(at, 1)[0];
        else {
          if (data.favourites.length >= 100) fail('Your collection can hold up to 100 artworks. Remove one first.');
          changedItem = snapshot(button); data.favourites.push(changedItem); added = true;
        }
      });
      track(added ? 'my_collection_add' : 'my_collection_remove', {
        product_id: changedItem.productId, variant_id: changedItem.variantId || '', saved_count: updated.favourites.length,
        source: button.hasAttribute && button.hasAttribute('data-um-my-collection-artwork') ? 'collection_grid' : button.closest('.um-my-collection-access') ? 'gallery' : button.closest('#sticky-add-to-cart') ? 'sticky_atc' : 'pdp'
      });
      message(added ? 'Saved to My Collection' : 'Removed from My Collection', added);
    } catch (e) { message(e.message); sync(); }
  });
  window.addEventListener('storage', function (event) { if (event.key === KEY || event.key === null) notify(); });
  document.addEventListener('visitorConsentCollected', notify);
  document.addEventListener('shopify:section:load', notify);
  window.UMMyCollection = { read: read, mutate: mutate, sync: sync, message: message, url: url, productLink: productLink, track: track,
    subscribe: function (fn) { listeners.push(fn); }, error: function () { return lastError; }, config: config, validate: validate };
  sync();
  if (window.MutationObserver && document.body) {
    new window.MutationObserver(function (records) {
      // Filtering, pagination and recommendations can insert cards after load.
      var hasNewHearts = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches('[data-um-my-collection-heart]') || node.querySelector('[data-um-my-collection-heart]'));
        });
      });
      if (hasNewHearts) sync();
    }).observe(document.body, {childList: true, subtree: true});
  }
  repairFavouriteImages();
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], notify);
  }
})();
